module.exports = __webpack_public_path__ + "static/media/Engage_Play_Tools_Logo.e130d578.png";